
<app-content-body class="h-100 px-2" >
<div class="container-fluid py-1 inner-container">

<div class="d-flex flex-row mt-5  mb-2">
  <div class="col">
    <div class="content-header d-flex justify-content-between">
        <div class="d-flex flex-row align-items-center">
            <fa-icon *ngIf='faCloud' [icon]='faCloud' class="align-self-center"></fa-icon>
            <p class="ms-2 title">{{title}}</p>
        </div>
    </div>
    <p class="content-header title" style="margin-left: 30px;">{{nextHeader}}</p>
</div>
</div>
<div class="d-flex flex-row" *ngIf="!isTransactionLink()">
  <div >
  <a class="btn wizard-button  ">Buy NCache </a>
</div>
<div >
  <a class="btn wizard-button ">Create Quotation </a>
</div>
<div >
  <a class="btn wizard-button underline">Preview Quotation </a>
</div>
</div>
    <div class="mt-4 flex-row col-12 row">
      <h2  class="text-danger mb-4" *ngIf="quotationApprovedMessage()">{{quotationApprovedMessage()}}</h2>

      <div class="col-sm-6">
        <div class="border">
          <div class="text-start border-bottom p-3 d-flex justify-content-between align-items-center bg-blue">
            <h6 class="d-inline my-auto">Company</h6>
          </div>
          <div>
            <div class="card-body  d-flex flex-column subscription-body p-3">
              <div class="row ">
                <div class="col-sm-2 fw-bold lh-lg ">Name:</div>
                <div class="col-sm-4 text-end">
                  {{ userDetails?.companyDetails?.name }}
                </div>
      
                <div class="col-sm-2 fw-bold lh-lg">State/Region:</div>
                <div class="col-sm-4 text-end">
                  {{ userDetails?.companyDetails?.state }}
                </div>
              </div>
              <div class="row ">
                <div class="col-sm-2 fw-bold lh-lg">Website:</div>
                <div class="col-sm-4 text-end">
                  {{ userDetails?.companyDetails?.url }}
                </div>
                <div class="col-sm-2 fw-bold lh-lg">Zip/Postal Code:</div>
                <div class="col-sm-4 text-end">
                  {{ userDetails?.companyDetails.postalCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg">Street:</div>
                <div class="col-sm-4 text-end">{{userDetails?.companyDetails?.address}}</div>
                <div class="col-sm-2 fw-bold lh-lg">Country:</div>
                <div class="col-sm-4 text-end">
                  {{ userDetails?.companyDetails?.country }}
                </div>   
              </div>
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg">City:</div>
                <div class="col-sm-2">
                  {{ userDetails?.companyDetails?.city }}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      
      <div class="col-sm-6">
        <div class="border">
          <div class="text-start border-bottom p-3 d-flex justify-content-between align-items-center bg-blue">
            <h6 class="d-inline my-auto">Contact</h6>
          </div>
          <div>
            <div class="card-body d-flex flex-column subscription-body p-3">
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg" >Name:</div>
                <div class="col-sm-10  text-nowrap text-end">
                  {{ userDetails?.primaryUser?.firstName }}
                  {{ userDetails?.primaryUser?.lastName }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg">Job Title:</div>
                <div class="col-sm-10  text-nowrap text-end">
                  {{ userDetails?.primaryUser?.jobTitle }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg">Phone:</div>
                <div class="col-sm-10  text-nowrap text-end">
                  {{ userDetails?.primaryUser?.phoneNumber }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2 fw-bold lh-lg">Email:</div>
                <div class="col-sm-10  text-nowrap text-end">
                  {{ userDetails?.primaryUser?.email }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" col-12  inner-container mt-5">
      <app-table
      class=" mt-5"
      [previewData]="previewData"
        [Enable24x7]="false"
        [previewModeOn]="isPreview"
        [isNonHostedQuotation]="checkIfsubscriptionNonHosted()"
        [isSupportQuotation]="isSupportQuotation"
        [subscriptionID]="subscriptionId"
        (navigateBack)="handlePreviewEnviromentsArray($event)"
        [isfromSales]="false"
        [finalCost]="previewFinalCost"
        (updatedFinalCost)="handleFinalCost($event)"
        [isMidYearQuotation]="checkIfQuotationMidYear()"
        >
      </app-table>
      </div>
    </div>
  </div>
  </app-content-body>
  <div class='footer bg-light' fxLayoutGap="25px" *ngIf="toggleButtons()">
    <button
      class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
      [disabled]="disablePreviousBtn"
        (click)="back()">
        Previous
    </button>

    <button
      class="btn btn-nc me-3 btn-sm submit btn-primary btn-width"
      [disabled] = "getQuotationStatus()"
      [ngClass]="{'btn-secondary':getQuotationStatus()}"
      (click)="submitQuotationFunction()"
      >
        {{confirmBtnTitle}}
    </button>

    <button
        class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
        [routerLink]="['/subscription/dashboard']">
        Close
    </button>
  </div>

